@if (toastItem()) {
  @if (toastItem().archive.status === 'resizing') {
    <div class="archive-icon-container">
      <app-circle-progress-bar
        [progress]="toastItem().resizeProgress"
        [size]="62"
        [strokeWidth]="12"
        [noBackgroundCircle]="true"
      ></app-circle-progress-bar>
      <img src="/assets/animations/download-resizing.svg" alt="" />
    </div>

    <div class="archive-info">
      <h3>Resizing Images</h3>
      <p>{{ toastItem().assetResizingDoneCount }} of {{ toastItem().assetCount }} images resized.</p>
    </div>
  } @else if (toastItem().completed) {
    <div class="archive-icon-container">
      <app-animated-svg src="/assets/animations/checkmark.svg"></app-animated-svg>
    </div>

    <div class="archive-info">
      @if (toastItem().partInfo) {
        <h3>Downloading ZIP {{ toastItem().partInfo.index + 1 }} of {{ toastItem().partInfo.total }}</h3>
      } @else {
        <h3>Download Started</h3>
      }

      <p>{{ toastItem().assetCount }} assets, {{ toastItem().archive.total_size | dataUnitsBigInt: 0 }}.</p>
    </div>
  } @else if (toastItem().progress) {
    <div class="archive-icon-container">
      <app-circle-progress-bar
        [progress]="toastItem().progress"
        [size]="62"
        [strokeWidth]="12"
        [noBackgroundCircle]="true"
      ></app-circle-progress-bar>
      <img src="/assets/animations/download-zipping.svg" alt="" />
    </div>

    <div class="archive-info">
      @if (toastItem().partInfo) {
        <h3>Creating ZIP {{ toastItem().partInfo.index + 1 }} of {{ toastItem().partInfo.total }}</h3>
      } @else {
        <h3>Creating ZIP-File</h3>
      }
      <p>
        {{ toastItem().progress | number: '1.0-0' }}% of
        {{ toastItem().archive.total_size | dataUnitsBigInt: 0 }} zipped.
      </p>
    </div>
  } @else {
    <div class="archive-icon-container">
      <img src="/assets/animations/download-preparing.svg" alt="" />
    </div>

    <div class="archive-info">
      <h3>Preparing Download</h3>
      <p>Collecting {{ toastItem().assetCount }} assets.</p>
    </div>
  }

  @if (!toastItem().completed) {
    <button
      appButton
      name="cancel"
      location="archive-download-info"
      color="simple-gray-60"
      height="1"
      [iconButton]="true"
      shape="round"
      (click)="archiveService.cancelArchive(toastItem())"
    >
      <app-svg src="/assets/icons/stop.svg"></app-svg>
    </button>
  }
}
